export default __webpack_public_path__ + "static/media/phcnKad.79db98de.svg";